var exports = {
  "h": "xa15a2ab7--3fccd5--dignity",
  "F": "xa15a2ab7--3fccd5--dignity_item",
};

module.exports = exports;
